import { render, staticRenderFns } from "./EnacAtplDashboardNotification.vue?vue&type=template&id=0ba25880"
import script from "./EnacAtplDashboardNotification.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports